import React, { useState, forwardRef, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import DialogContentText from "@material-ui/core/DialogContentText";

import Typography from "@material-ui/core/Typography";

import Slide from "@material-ui/core/Slide";
import { useDispatch } from "react-redux";
import { setAlertDialog } from "../../modules/App/actions";
import { withStyles, ThemeProvider, useTheme } from "@material-ui/styles";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  content: {
    padding: theme.spacing(4),
    color: theme.palette.text.primary,
  },
}));

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" align="center">
        {children}
      </Typography>
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(0),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AppAlertDialog({
  open = false,
  title = "",
  content = "",
  agreeText = "Yes",
  disagreeText = "No",
  onAgree,
  onDisagree,
  showActions = true,
  showTitle = true,
  fullScreen = false,
  fullWidth = false,
  maxWidth = "lg",
}) {
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleClose = () => {
    dispatch(setAlertDialog());
  };

  const _onAgree = () => {
    if (onAgree) onAgree();
    handleClose();
  };

  const _onDisagree = () => {
    if (onDisagree) onDisagree();
    handleClose();
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      className="custom-dialog"
      fullScreen={fullScreen}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
    >
      {showTitle && <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>}
      <DialogContent>
        <div id="alert-dialog-slide-description" className={classes.content}>
          {content}
        </div>
      </DialogContent>
      {showActions && (
        <DialogActions>
          <Button onClick={_onAgree} color="primary" variant="contained">
            {agreeText}
          </Button>
          <Button onClick={_onDisagree} color="secondary" variant="contained">
            {disagreeText}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
}
